/**
 * The Vihangam Yog mark — the gold अ rendered as a Tiro Devanagari
 * vector glyph. Fixed amber regardless of active variant. Vector,
 * so no PNG artefacts at any size, and recolours via `colour` prop
 * when a surface needs it ink-on-cream or paper-on-ink.
 */
export function Mark({
  size = 48,
  alt = "Vihangam Yog",
  colour = "var(--amber)",
}: {
  size?: number;
  alt?: string;
  colour?: string;
}) {
  return (
    <span
      role="img"
      aria-label={alt}
      className="font-devanagari"
      style={{
        display: "inline-block",
        width: size,
        height: size,
        lineHeight: `${size}px`,
        fontSize: size * 1.08,
        color: colour,
        textAlign: "center",
        fontWeight: 400,
        userSelect: "none",
      }}
    >
      अ
    </span>
  );
}

/**
 * Logo + wordmark + tagline as a single horizontal lockup. Used as
 * the default brand block on hero areas, business cards, and email
 * headers. The wordmark and tagline read in the active variant's
 * type system; only the mark itself is fixed amber.
 */
export function Lockup({
  glyphSize = 48,
  wordmarkSize = 16,
  taglineSize = 13,
  showTagline = true,
  tone = "dark",
}: {
  glyphSize?: number;
  wordmarkSize?: number;
  taglineSize?: number;
  showTagline?: boolean;
  tone?: "dark" | "light";
}) {
  const wordColour = tone === "light" ? "var(--paper)" : "var(--ink)";
  const tagColour = tone === "light" ? "var(--peach)" : "var(--ink-soft)";

  return (
    <div className="flex items-center gap-3">
      <Mark size={glyphSize} />
      <div className="flex flex-col gap-1 leading-tight">
        <span
          className="font-body font-semibold uppercase whitespace-nowrap"
          style={{
            fontSize: wordmarkSize,
            letterSpacing: "0.28em",
            color: wordColour,
          }}
        >
          Vihangam Yog
        </span>
        {showTagline && (
          <span
            className="font-display italic whitespace-nowrap"
            style={{
              fontSize: taglineSize,
              letterSpacing: "0.04em",
              color: tagColour,
            }}
          >
            Science of Consciousness
          </span>
        )}
      </div>
    </div>
  );
}
